// When you are the tenant you can add receipts with any date
export const isTenant334081949181 = (tenantId: number) =>
  [334081949181].includes(tenantId)
